import { useEffect } from 'react';
import { useNav } from './stores/navigation';
import { useUnlocked } from './stores/unlocked';
import { parseARQr, failureMessage } from './qr/parser';
import { HomeScreen } from './screens/HomeScreen';
import { ScannerScreen } from './screens/ScannerScreen';
import { CollectionScreen } from './screens/CollectionScreen';
import { CharacterDetailScreen } from './screens/CharacterDetailScreen';
import { ArScreen } from './screens/ArScreen';

/**
 * URL のハッシュに `#msqr:v2:...` が乗っていれば、起動と同時にキャラを
 * アンロックして詳細画面へ遷移する。
 *   例: https://ms-qr.pages.dev/#msqr:v2:eyJ...
 * これにより 1 つの QR で「アプリ起動 + キャラ読込」が完結する。
 */
function useDeepLinkUnlock() {
  useEffect(() => {
    const raw = location.hash.startsWith('#') ? location.hash.slice(1) : '';
    if (!raw.startsWith('msqr:')) return;

    const parsed = parseARQr(raw);
    if (!parsed.ok) {
      console.warn('[deeplink] parse failed:', failureMessage(parsed.reason));
      return;
    }

    useUnlocked.getState().unlock(parsed.params);
    const entry = { ...parsed.params, unlockedAt: new Date().toISOString() };
    useNav.getState().go({ kind: 'detail', entry });

    // ハッシュを消してリロード時の再発火を防止
    history.replaceState(null, '', location.pathname + location.search);
  }, []);
}

export function App() {
  const screen = useNav((s) => s.screen);
  useDeepLinkUnlock();

  return (
    <div className="app">
      {screen.kind === 'home' && <HomeScreen />}
      {screen.kind === 'scanner' && <ScannerScreen />}
      {screen.kind === 'collection' && <CollectionScreen />}
      {screen.kind === 'detail' && <CharacterDetailScreen entry={screen.entry} />}
      {screen.kind === 'ar' && <ArScreen entry={screen.entry} />}
    </div>
  );
}
